/**
 * vuex store의 state에서 사용.
 * serviceData의 인자값 타입으로 사용.
 */
export class FormDataUserPermissionSettingDialog {
    userMenuAuthorities = [];
    constructor(list) {
        if (!list) {
            return;
        }
        this.userMenuAuthorities = list.map((item) => ({
            code: item.code,
            isAuthorized: item.isAuthorized,
        }));
    }
}
